import React from "react";
import styleError from "./ErrorBoundary.module.scss";

interface IPropsErrorBoundary {
  pathname?: string,
  children: any,
}

interface IStateErrorBoundary {
  hasError: boolean,
  pathname: string,
}

export class ErrorBoundary extends React.Component <IPropsErrorBoundary, IStateErrorBoundary> {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      pathname: '',
    };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps: Readonly<IPropsErrorBoundary>, prevState: Readonly<IStateErrorBoundary>): void {
    if(this.props.pathname && this.props.pathname !== prevState.pathname) {
      this.setState({ hasError: false, pathname: this.props.pathname });
    }
  }

  render() {
    return(
      <>
        {(this.state.hasError) ? 
          <div className={styleError.error}>
            <p>oops, something went wrong</p>
          </div>
        : this.props.children
        }
      </>
    )
  }
}